// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M8.35 1.75H5C3.9 1.75 3 2.65 3 3.75V12.25C3 13.35 3.9 14.25 5 14.25H10.5C11.6 14.25 12.5 13.35 12.5 12.25V8.5',
  'M1.5 4.25H4.5M1.5 6.75H4.5M1.5 9.25H4.5M1.5 11.75H4.5',
  'M13.44 3.59L14.1 2.92C14.44 2.58 14.38 1.97 13.97 1.56C13.56 1.15 12.95 1.09 12.61 1.43L11.94 2.09L8.19 5.84C8.01 6.03 7.89 6.27 7.84 6.55L7.64 7.66C7.62 7.78 7.75 7.91 7.87 7.89L8.98 7.69C9.26 7.64 9.5 7.52 9.69 7.34L13.44 3.59ZM11.94 2.09L12.14 2.47C12.35 2.86 12.67 3.18 13.06 3.39L13.44 3.59',
];
